import BasePageApprove from '@/found/modules/table_page_approve';
import Table from './table';
// test
export default {
  extends: BasePageApprove,
  components: {
    Table,
  },
};
